module.exports = new __parcel__URL__("EnergyPlant.8aecfd34.png").toString();